import { Controller } from '@hotwired/stimulus';
import { Gradient } from '../helpers/animation_helper';

// For loading the animation on the landing
export default class extends Controller {
  connect() {
    new Gradient().initGradient('#canvas-gradient');
  }
}
